module.exports = __webpack_public_path__ + "img/guide14.14a2a437.jpg";